import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { SpinnerComponent } from './shared/components/ui/spinner/spinner';
import { NotificationComponent } from './shared/components/ui/notification/notification';
import { FooterComponent } from './shared/components/ui/footer/footer.component';
import { HeaderComponent } from './shared/components/ui/header/header.component';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { filter } from 'rxjs/operators';
import { PreferitiStateService } from './core/services/preferiti-state.service';
import { FascicoloStateService } from './core/services/fascicolo-state.service';
import { AuthService } from './core/services/auth.service';
import { RouteFocusService } from './core/services/route-focus.service';
import { BaseComponent } from './shared/components/base.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    NotificationComponent,
    SpinnerComponent,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent extends BaseComponent {
  authService = inject(AuthService);
  fascicoloStateService = inject(FascicoloStateService);
  preferitiStateService = inject(PreferitiStateService);
  router = inject(Router);
  private routeFocusService = inject(RouteFocusService);

  /** Sposta il focus (e lo scroll) su <main> senza toccare l'URL né ricaricare la pagina */
  skipToMain(event: Event): void {
    event.preventDefault();
    const main = document.getElementById('contenuto-principale');
    main?.focus();
    main?.scrollIntoView();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    // Lo stato di autenticazione è già risolto dall'APP_INITIALIZER (vedi app.config.ts)
    // prima che l'app venga bootstrappata, quindi qui leggiamo il risultato senza rifare la chiamata.
    if (this.authService.isAuthenticated()) {
      this.fascicoloStateService.loadFromApi();
      this.preferitiStateService.loadFromApi();
    } else {
      this.fascicoloStateService.loadAnon();
      this.preferitiStateService.clear();
    }

    // Scroll to top on every navigation end to ensure pages open at top
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        try {
          window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        } catch (e) {
          // ignore in non-browser environments
        }
      });
  }
}
